export default {
  Planned: 'Planned',
  InProgress: 'InProgress',
  Over: 'Over',
};
